module.exports = __webpack_public_path__ + "877ede47d0552b43280970d458aacba9.jpg";